import DistributeSides from './DistributeSides';
import type { SortSide, SortSideItem } from './utils';

export { SortSide, SortSideItem };
export default DistributeSides;
